module.exports = __webpack_public_path__ + "img/poly-11.75c4011a.png";